import axios from 'axios';

export interface City {
    nom: string;
    code: string;
    _score: string;
    departement: {
        code: string;
        nom: string;
    };
}

export default function cities(name: string) {
    return axios.get<City[]>(
        `https://geo.api.gouv.fr/communes?nom=${name}&fields=departement&boost=population&limit=5`
    );
}
